import React from 'react';

interface AlertIconProps {
  className?: string;
  size?: number;
}

export const AlertIcon: React.FC<AlertIconProps> = ({ className = "", size = 17 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 17 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_16605_31691)">
        <path 
          d="M14.863 12.2875L9.44632 2.80832C9.32821 2.59992 9.15693 2.42657 8.94996 2.30597C8.74299 2.18537 8.50773 2.12183 8.26819 2.12183C8.02865 2.12183 7.79339 2.18537 7.58642 2.30597C7.37945 2.42657 7.20817 2.59992 7.09007 2.80832L1.6734 12.2875C1.55402 12.4942 1.49142 12.7289 1.49195 12.9676C1.49248 13.2064 1.55611 13.4407 1.67641 13.6469C1.79671 13.8532 1.96938 14.0239 2.17694 14.1419C2.3845 14.2599 2.61956 14.3209 2.85829 14.3187H13.6916C13.9292 14.3185 14.1626 14.2557 14.3682 14.1368C14.5739 14.0178 14.7446 13.8469 14.8633 13.6411C14.982 13.4352 15.0445 13.2018 15.0444 12.9642C15.0443 12.7266 14.9818 12.4932 14.863 12.2875Z" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M8.2749 6.19373V8.90206" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M8.2749 11.6104H8.28167" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16605_31691">
          <rect width="16.25" height="16.25" fill="white" transform="translate(0.149902 0.0999756)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
